'use strict';
var LoaderType;
(function (LoaderType) {
    LoaderType["Skeleton"] = "skeleton";
    LoaderType["Circle"] = "circle";
    LoaderType["Square"] = "square";
    LoaderType["None"] = "none";
})(LoaderType || (LoaderType = {}));
export default LoaderType;
